import { render } from "./transfer_templates_new.vue?vue&type=template&id=1f5633b2"
import script from "./transfer_templates_new.vue?vue&type=script&lang=js"
export * from "./transfer_templates_new.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__